var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPredio = function SvgPredio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#ECF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 26C26 24.067 27.567 22.5 29.5 22.5H50.5C52.433 22.5 54 24.067 54 26V55.75C54 56.7165 53.2165 57.5 52.25 57.5H45.25C44.2835 57.5 43.5 56.7165 43.5 55.75V45.25H36.5V55.75C36.5 56.7165 35.7165 57.5 34.75 57.5H27.75C26.7835 57.5 26 56.7165 26 55.75V26ZM52.25 36.5V41.75H48.75V36.5H52.25ZM45.25 36.5H41.75V41.75H45.25V36.5ZM34.75 36.5H38.25V41.75H34.75V36.5ZM31.25 36.5H27.75V41.75H31.25V36.5ZM52.25 27.75V33H48.75V27.75H52.25ZM45.25 27.75H41.75V33H45.25V27.75ZM34.75 27.75H38.25V33H34.75V27.75ZM31.25 27.75H27.75V33H31.25V27.75Z",
    fill: "#498FFF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPredio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/predio.81e7d686.svg";
export { ForwardRef as ReactComponent };